// extracted by css-extract-rspack-plugin
export default {"breadCrumbWrapper":"xTlik","formWrapper":"gRbjh"};